import { gql, useLazyQuery } from '@apollo/client';
import { AnyObject } from '../../../models/types';
import { GetMetricsData } from '../../../Domain/ClusterInsights/Hooks/useGetMetricsQuery';

export interface ClusterInfoVars {
  domainIdentifier: string;
  instanceId: string;
}

export interface ElasticResponse {
  cluster: {
    health?: AnyObject;
    settings?: AnyObject;
    stats?: AnyObject;
    state?: AnyObject;
    allocationExplain?: AnyObject;
    decommission?: AnyObject
  };
  cat: {
    nodes?: AnyObject;
  };
}

export interface KibanaResponse {
  health: 'red' | 'green' | 'yellow' | string;
}

export interface ClusterInfoData {
  domain: {
    es60: ElasticResponse;
    kibana: {
      health: KibanaResponse;
    };
    clusterData: {
        serverType: string;
        discoveryMode: string;
    };
  };
}

export const CLUSTER_INFO = gql`
  query getClusterInfo($domainIdentifier: String!, $instanceId: String!, $piezoArtifacts: JSON) {
    domain(domainIdentifier: $domainIdentifier, instanceId: $instanceId, piezoArtifacts: $piezoArtifacts) {
      es60 {
        cluster {
          health
          settings
          stats
          state
          allocationExplain
          decommission
        }
        cat {
          nodes
        }
      }
      kibana {
        health
      }
      clusterData {
        serverType
        discoveryMode
      }
    }
  }
`;

export const useClusterInfoQuery = () => {
  // Lazy query fired imperatively. piezoLink derives + signs the migrated cluster tools from the
  // query's selection set and execution variables (signing/fieldRegistry) and injects the
  // $piezoArtifacts map, so no per-hook descriptor wiring is needed here.
  return useLazyQuery<ClusterInfoData, ClusterInfoVars>(CLUSTER_INFO, {
    errorPolicy: 'all',
  });
};

export const fetchClusterInfo = async (
  client: any,
  domainIdentifier: string,
  instanceId: string,
): Promise<string[]> => {
  const { data } = await client.query({
    query: CLUSTER_INFO,
    variables: {
      domainIdentifier,
      instanceId,
    },
    fetchPolicy: 'no-cache',
  });
  return data;
};
